<ng-content></ng-content>
<ion-toast position="top" [duration]="5000"></ion-toast>
